import React from 'react';
import { StepProps } from '../../types/form';
import { FormField } from '../ui/FormField';
import { SelectDropdown } from '../ui/SelectDropdown';
export function SubgroupsStep({
  formData,
  updateFormData,
  errors
}: StepProps) {
  return <div className="space-y-6" data-id="element-235">
      <div data-id="element-236">
        <h2 className="text-lg font-semibold text-foreground" data-id="element-237">Subgroups & Users</h2>
        <p className="text-sm text-muted-foreground" data-id="element-238">
          Can this organization create nested groups and invite members?
        </p>
      </div>

      <FormField id="needSubgroups" label="Can they create subgroups?" required error={errors.needSubgroups} data-id="element-239">
        <div className="flex gap-3" data-id="element-240">
          {[{
          label: 'Yes',
          value: true
        }, {
          label: 'No',
          value: false
        }].map(opt => <button key={String(opt.value)} type="button" onClick={() => updateFormData({
          needSubgroups: opt.value,
          subgroupLevels: opt.value ? formData.subgroupLevels : null
        })} className={`px-4 py-2 rounded-md text-sm font-medium border transition-colors ${formData.needSubgroups === opt.value ? 'bg-violet-blue text-white border-violet-blue' : 'bg-background border-input text-foreground hover:bg-muted'}`} data-id="element-241">
              {opt.label}
            </button>)}
        </div>
      </FormField>

      {formData.needSubgroups && <FormField id="subgroupLevels" label="How many levels of subgroups?" required hint="Group admins can create subgroups and invite members into different groups." error={errors.subgroupLevels} data-id="element-242">
          <SelectDropdown id="subgroupLevels" value={formData.subgroupLevels || ''} onChange={val => updateFormData({
        subgroupLevels: parseInt(val as string, 10)
      })} placeholder="Select number of levels" options={[{
        label: '1 Level',
        value: '1'
      }, {
        label: '2 Levels',
        value: '2'
      }, {
        label: '3+ Levels',
        value: '3'
      }]} error={!!errors.subgroupLevels} data-id="element-243" />
        </FormField>}

      <FormField id="numberOfUsers" label="How many users can each account invite?" hint="Enter 0 for single-user accounts (no invitations). Leave blank if unlimited." data-id="element-244">
        <SelectDropdown id="numberOfUsers" value={formData.numberOfUsers === '' ? 'unset' : String(formData.numberOfUsers)} onChange={val => updateFormData({
        numberOfUsers: val === 'unset' ? '' : parseInt(val as string, 10)
      })} options={[{
        label: 'Not specified',
        value: 'unset'
      }, {
        label: '0 (Single User)',
        value: '0'
      }, {
        label: '5',
        value: '5'
      }, {
        label: '10',
        value: '10'
      }, {
        label: '25',
        value: '25'
      }, {
        label: '50',
        value: '50'
      }, {
        label: '100',
        value: '100'
      }]} data-id="element-245" />
      </FormField>
    </div>;
}